import axios from "axios";
import { API_URL } from "../../../setup/config/env";

export const getQrTable= async ()=> {
    try{
        const response = await axios.get(`${API_URL}/api/qrDining/`, {
            headers:{
                "Content-type":"application/json"
            }
        })
        return response.data
    }
    catch(error){
        console.error("Error getting QR Table: ", error)
        throw error
    }
}

export const getQrTableById = async ({tableId}) =>{
    try{
        const response = await axios.post(`${API_URL}/api/qrDining/`, {_id: tableId}, {
            headers:{
                "Content-type":"application/json"
            }
        })
        return response.data
    }
    catch(error){
        console.error("Error getting QR Table by Id: ", error)
        throw error
    }
}